export default __webpack_public_path__ + "static/VehicleSliderWithDraftJsTitle-1d49491a582982cf7d48f4df1e3b67a6.jpg";